import { isObject, isString } from '@/common/utils'
import logger from '@/logger'
import type { ChatInputType, Operator } from '@/types'



export const parseAgentData = (data: Operator): Operator => {
  const agentData = {
    name: data.display_name || data.name || 'Livechat Agent',
    title: data.title || data.titel || '',
    avatar_url: data.avatar_url || ''
  }

  if (data.avatar_base64) {
    agentData.avatar_url = `data:image/png;base64,${data.avatar_base64}`
  }
  return agentData
}

const INPUTTYPES = ['cancel', 'textinput', 'fileupload', 'disabled']
export const parseInputType = (value: ChatInputType | undefined | string = { type: 'textinput' }): ChatInputType => {
  if (!value) {
    logger.warn('no input type -> fallback to default')
    return { type: 'textinput' }
  }

  if (isString(value)) {
    // this was a simple string at some point in time
    // if this is still in the config, we upgrade to the "new object format"
    if (!INPUTTYPES.includes(value as string)) {
      console.warn('unknown input type -> fallback to default')
      return { type: 'textinput' }
    }
    console.warn('deprecated config parts -> inputType')
    return {
      // whatever typescript says, this is a string
      type: value as unknown as string
    }
  }

  // After here we have an object

  if (!isObject(value)) {
    console.warn('no valid input type -> fallback to default')
    return { type: 'textinput' }
  }
  if (!isObject(value) || !INPUTTYPES.includes((value as ChatInputType).type)) {
    console.warn('unknown input type -> fallback to default')
    return { type: 'textinput' }
  }
  // Typescript is not able to infer the return value as ChatInputType
  return value as ChatInputType
}
